import { useContext, useEffect, useState } from "react";
import Special from "@/components/specials/Special";
import SkeletonElement from "@/components/skeletons/SkeletonElement";
import styles from "./Grid.module.scss";
import Header from "@/components/shop/Header";
import Button from "@/components/Button";
import GridIcon from "/packages/icons/grid.svg";
import CalendarIcon from "/packages/icons/calendar.svg";

import StoreContext from "@/context/store";
import { useSpecials } from "@/context/specials";
import Calendar from "@/components/calendar/Calendar";

export default function SpecialsGrid({ title = "Specials", subtitle }) {
  const { store } = useContext(StoreContext);
  const { specials, fetchAllSpecials } = useSpecials();
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("Grid");

  useEffect(() => {
    if (store) {
      fetchAllSpecials(store);
    }
  }, [store, fetchAllSpecials]);

  useEffect(() => {
    if (specials?.length > 0) {
      setLoading(false);
    }
  }, [specials]);

  const sortedSpecials = [...specials].sort(
    (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
  );

  return (
    <>
      <Header category={title} subtitle={subtitle} flexChildren>
        <div className="deals-toggle">
          <Button
            type="button"
            className={`toggle ${view === "Grid" ? "toggle-active" : "toggle-inactive"}`}
            onClick={() => setView("Grid")}
          >
            <GridIcon />
            Grid
          </Button>
          <Button
            type="button"
            className={`toggle ${view === "Calendar" ? "toggle-active" : "toggle-inactive"}`}
            onClick={() => setView("Calendar")}
          >
            <CalendarIcon />
            Calendar
          </Button>
        </div>
      </Header>

      <div className={styles.wrapper}>
        {loading ? (
          <div className={styles.grid}>
            {[...Array(12)].map((_, index) => (
              <div key={index}>
                <SkeletonElement type="special" />
              </div>
            ))}
          </div>
        ) : view === "Calendar" ? (
          <Calendar specials={sortedSpecials} />
        ) : (
          <div className={styles.grid}>
            {sortedSpecials.map((item) => (
              <Special key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </>
  );
}
